/**
 * @author Indeform Ltd
 * @copyright Copyright 2018, Indeform Ltd
 * @version 20200514
 * @description Consultant terms and conditions agreement modal.
 */


import ModalWindow from "./modal-window";


class ConsultantTermsModal extends ModalWindow {
    constructor(ui) {
        super(ui, 'consultantTermsModal', ['click'], {
            elmDestination: 'id_is_consultant',
            elmReceiveConsultationInvite: 'id_receive_consult_invitation_mail',
        });
    }


    open(data) {
        if (this.elmDestination.checked) super.open(data);
    }


    on_modalClose(data, e) {
        super.on_modalClose(data, e);

        this.elmDestination.checked = false;
    }


    on_modalSubmit(data, e) {
        let receiveConsultationInvite = document.getElementById(
            this.params.elmReceiveConsultationInvite);
        
        if (receiveConsultationInvite &&
                    receiveConsultationInvite.hasAttribute('hidden')) {
            let parentNode = receiveConsultationInvite.parentNode.parentNode.parentNode;
                        
            receiveConsultationInvite.removeAttribute('hidden');
            parentNode.classList.remove('hidden');
        }

        super.on_modalSubmit();
    }
}

export { ConsultantTermsModal }
export default ConsultantTermsModal
